// eslint-disable-next-line import/no-anonymous-default-export
export default {
  meEndpoint: '/auth/me',
  storageTokenKeyName: 'faham-admin-panel-web-accessToken',
  storageUserDataKeyName: 'faham-admin-panel-web-portal-userData',
}
